import { STARTUP_PROGRESS_BAR_SECONDS } from '../game/constants';

export const STARTUP_OVERLAY_CONFIG = {
  progressBarSeconds: STARTUP_PROGRESS_BAR_SECONDS,
  progressTickMs: 80,
  statusRotateMs: 2000,
} as const;

export const INIT_MAINTENANCE_GRACE_MS = 60_000;
